import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, combineLatest, Subject, takeUntil } from 'rxjs';

type ProgressTypes = 'info' | 'success' | 'danger';

@Component({
  selector: 'app-modal-upload-images',
  templateUrl: './modal-upload-images.component.html',
  styleUrls: ['./modal-upload-images.component.scss'],
})
export class ModalUploadImagesComponent implements OnInit, OnDestroy {
  @Input() progress$!: BehaviorSubject<number>;
  @Input() failed$!: BehaviorSubject<boolean>;

  progressType$ = new BehaviorSubject<ProgressTypes>('info');
  progressText$ = new BehaviorSubject<string>('0%');
  done = false;
  isFailed = false;
  content = {
    heading: 'Uploading',
    icon: 'info',
    info: 'Please do not close this window',
  };

  private destroyed$ = new Subject<void>();

  constructor(private modal: NgbActiveModal) {}

  ngOnInit(): void {
    combineLatest([this.progress$, this.failed$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([progress, failed]) => {
        if (failed) {
          this.progressType$.next('danger');
          this.progressText$.next('Failed');
          this.content = {
            heading: 'Upload Failed',
            icon: 'error',
            info: 'Some images failed to upload! Please try again later.',
          };
          this.done = true;
          this.isFailed = true;
          return;
        }
        if (progress === 100) {
          this.progressType$.next('success');
          this.progressText$.next('Completed');
          this.content = {
            heading: 'Upload Success',
            icon: 'done',
            info: 'All images has been successfully uploaded.',
          };
          this.done = true;
          return;
        }

        this.progressText$.next(`${progress}%`);
      });
  }

  get showProgress(): boolean {
    return this.progress$.value > 0 && !this.isFailed;
  }

  close(confirmed: boolean): void {
    this.modal.close(confirmed);
  }

  ngOnDestroy(): void {
    this.progress$.unsubscribe();
    this.failed$.unsubscribe();
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
